<template>
  <v-snackbar
    class="snackbar"
    centered
    :timeout="snackbar.timeout"
    v-model="snackbar.show"
  >
    <template v-if="snackbar.type === 'lang'">
      {{ $t(snackbar.text) }}
    </template>
    <template v-else>
      {{ snackbar.text }}
    </template>
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        @click="setSnackbar({ show: false, text: '' })"
      >
        <v-icon class="fz-14-px">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'Snackbar',

  props: ['timeoutData'],

  data() {
    return {}
  },

  computed: {
    ...mapState('message', ['snackbar'])
  },

  watch: {
    'snackbar.show': function () {
      if (this.snackbar.text === 'LOGINERROR_1') {
        this.ChangeDialog('Login')
      }
    }
  },

  methods: {
    ...mapMutations('common', ['ChangeDialog']),
    ...mapActions('message', ['setSnackbar'])
  }
}
</script>

<style lang="scss" scoped>
</style>
